import { render, staticRenderFns } from "./TournamentRulesCard.vue?vue&type=template&id=67ce8c18&"
import script from "./TournamentRulesCard.vue?vue&type=script&lang=ts&"
export * from "./TournamentRulesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardTitle,VChip,VChipGroup,VListItemSubtitle})
